var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { GenericRequest, METHOD } from "./GenericRequest";
/**
 * Does the same things as GenericRequest but it also gives the ability to cancel the request or set a timeout for it.
 *
 * Changes execution implementation.
 *
 * <p>
 * @inheritDoc{GenericRequest}
 * </p>
 * @abstract
 */

var CancellableGenericRequest =
/** @class */
function (_super) {
  __extends(CancellableGenericRequest, _super);
  /**
   * @inheritDoc
   */


  function CancellableGenericRequest(method, url, generalErrorMessage) {
    if (method === void 0) {
      method = METHOD.METHOD_POST;
    }

    var _this = _super.call(this, method, url, generalErrorMessage) || this;

    _this.httpRequest = new XMLHttpRequest();
    _this.getRequestDataFor = _this.getRequestDataFor.bind(_this);
    _this.sendRequest = _this.sendRequest.bind(_this);
    _this.setTimeout = _this.setTimeout.bind(_this);
    _this.addHeader = _this.addHeader.bind(_this);
    return _this;
  }
  /**
   * Aborts and resets the request so it can be executed again.
   */


  CancellableGenericRequest.prototype.resetRequest = function () {
    this.httpRequest.abort();
    this.httpRequest = new XMLHttpRequest(); // this.httpRequest.open(this.method, this.url, true);

    return this;
  };
  /**
   * @inheritDoc
   */


  CancellableGenericRequest.prototype.sendRequest = function (request) {
    var _this = this;

    if (this.method === METHOD.METHOD_GET) {
      this.url = this.getUrlForGETMethod();
    }

    this.onBeforeSendRequest();
    this.httpRequest.open(this.method, this.url, true);
    Object.keys(this.headers).forEach(function (key) {
      return _this.httpRequest.setRequestHeader(key, _this.headers[key]);
    });
    return new Promise(function (resolve, reject) {
      _this.httpRequest.onreadystatechange = function () {
        if (_this.httpRequest.readyState === 4) {
          try {
            _this.httpRequest._bodyText = _this.httpRequest.responseText;
            resolve(_this.httpRequest);
          } catch (e) {
            reject(e);
          }
        }
      };

      _this.httpRequest.send(_this.getRequestDataFor(request));
    });
  };
  /**
   * Set a callback that is going to be executed whe the request times-out.
   *
   * @param timeoutFunc Timeout callback function
   */


  CancellableGenericRequest.prototype.onTimeout = function (timeoutFunc) {
    this.httpRequest.ontimeout = timeoutFunc;
  };
  /**
   * Aborts the current WS.
   */


  CancellableGenericRequest.prototype.abort = function () {
    this.httpRequest.abort();
  };
  /**
   * Set a maximum time to wait before the requests gets cancelled by a time-out.
   *
   * @param {number} timeInMs
   * @instance
   */


  CancellableGenericRequest.prototype.setTimeout = function (timeInMs) {
    this.httpRequest.timeout = timeInMs;
  };
  /**
   * Inner function that converts the GenericRequest request into a XMLHttpRequest request.
   *
   * @param {RequestType} request
   * @return {RequestType}
   */


  CancellableGenericRequest.prototype.getRequestDataFor = function (request) {
    if (this.method === METHOD.METHOD_GET) return undefined;
    if (request instanceof FormData || typeof request === "string") return request;else return JSON.stringify(request);
  };

  return CancellableGenericRequest;
}(GenericRequest);

export { CancellableGenericRequest };